import { FC, Fragment } from 'react'
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch'
import styled from 'styled-components'
import { mobileBreakPoint } from 'app.styled/media'

type TProps = {
  imageUrl: string | undefined
  isMulti: boolean
}

const NewsItemImageZoom: FC<TProps> = ({ imageUrl, isMulti }) => {
  return (
    <StyledWrapper isMulti={isMulti}>
      <TransformWrapper wheel={{ disabled: true }} minScale={1} maxScale={5}>
        {({ zoomIn, zoomOut, state }) => (
          <Fragment>
            <div className="tools">
              <button
                onClick={() => zoomIn()}
                className={`${state.scale === 5 && 'btn-disabled'}`}
              >
                <img
                  src="/static/images/new_main/icon/btn_enlargement.png"
                  alt="확대"
                />
              </button>
              <button
                onClick={() => zoomOut()}
                className={`${state.scale === 1 && 'btn-disabled'}`}
              >
                <img
                  src="/static/images/new_main/icon/btn_reduction.png"
                  alt="축소"
                />
              </button>
            </div>
            <TransformComponent
              wrapperClass="transform-wrapper"
              contentClass="content-wrapper"
            >
              <img className="image" src={imageUrl} alt="기업채널 소식" />
            </TransformComponent>
          </Fragment>
        )}
      </TransformWrapper>
    </StyledWrapper>
  )
}

export default NewsItemImageZoom

const StyledWrapper = styled.div<{ isMulti }>`
  position: absolute;
  width: 100%;
  height: 100%;

  .tools {
    position: absolute;
    top: 24px;
    right: ${({ isMulti }) => (isMulti ? '98px' : '20px')};
    z-index: 1;
    button {
      color: #fff;
      background-color: rgba(51, 51, 51, 0.55);
      font-size: 12px;
      height: 40px;
      padding: 0 10px;
      border: none;
      border-radius: 3px;
      margin-left: 8px;
      cursor: pointer;
      img {
        width: 20px;
      }
    }
    .btn-disabled {
      opacity: 0.4;
    }
  }

  .transform-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
  }

  .content-wrapper {
    width: 100%;
    height: 100%;
  }

  .image {
    width: 100%;
    height: auto;
    object-fit: contain;
    aspect-ratio: 1 / 1;
    object-position: center;
  }

  ${mobileBreakPoint} {
    .tools {
      display: none;
    }
  }
`
